import type { AnalysisServerRow } from '@/app/PageSpeed/api/types/analysisApiTypes';

export type PlaceOption = {
  value: string;
  label: string;
  flag?: string;
  icon?: string | [string, string];
  isDisabled?: boolean;
  description?: string | null;
};

export type DeviceOption = { value: string; label: string; icon: string };
export type InternetOption = { value: string; label: string };

export const placeOptions: PlaceOption[] = [
  {
    value: 'ir',
    label: 'سرور ایران',
    flag: `https://static.mizfa.tools/flags/ir.webp`
  },
  {
    value: 'not_ir',
    label: 'سرور خارج',
    icon: 'globe'
  },
  {
    value: 'google',
    label: 'سرور گوگل',
    icon: ['fab', 'google']
  }
];

export const deviceOptions: DeviceOption[] = [
  {
    value: 'mobile',
    label: 'گوشی',
    icon: 'mobile-alt'
  },
  {
    value: 'desktop',
    label: 'رایانه',
    icon: 'desktop'
  }
];

export const internetOptions = [
  'wifi',
  'fast 4G',
  'regular 4G',
  'regular 3G',
  'good 3G',
  'slow 3G',
  'regular 2G',
  'good 2G'
];

export const internetSelectOptions: InternetOption[] = internetOptions.map(
  net => ({
    label: net.toUpperCase(),
    value: net
  })
);

export const defaultPlaceOption = placeOptions[0];
export const defaultDeviceOption = deviceOptions[0];
export const defaultInternetOption = internetSelectOptions[0];

export const applyServerStatusToPlaceOptions = (
  rows: AnalysisServerRow[] | undefined
): PlaceOption[] => {
  const statusByCode = Object.fromEntries(
    (rows ?? []).map(row => [row.location_code, row])
  );
  return placeOptions.map(option => {
    const server = statusByCode[option.value];
    const isDisabled = Boolean(server && server.status !== 'active');
    return {
      ...option,
      isDisabled,
      description:
        server?.description ||
        (isDisabled ? 'این سرور در حال حاضر در دسترس نیست' : null)
    };
  });
};

export const analysisSelectStyles = (borderRadius: string) => ({
  control: (baseStyles: Record<string, unknown>) => ({
    ...baseStyles,
    paddingLeft: '0px',
    paddingRight: '10px',
    color: 'var(--falcon-emphasise) !important',
    boxShadow: 'none !important',
    cursor: 'pointer',
    borderRadius,
    minHeight: '38px',
    height: '38px'
  }),
  valueContainer: (baseStyles: Record<string, unknown>) => ({
    ...baseStyles,
    height: '38px',
    paddingTop: 0,
    paddingBottom: 0
  }),
  indicatorsContainer: (baseStyles: Record<string, unknown>) => ({
    ...baseStyles,
    height: '38px'
  }),
  input: (baseStyles: Record<string, unknown>) => ({
    ...baseStyles,
    color: 'var(--falcon-emphasise) !important',
    boxShadow: 'none !important'
  })
});
